import axios from "axios";

export const downloadFileWithProgress = async (
  filePath: string,
  // onProgress?: (progress: number) => void,
  onCancel: () => void,
  signal: AbortSignal,
  fileName: string,
) => {
  try {
    const response = await axios.get(filePath, {
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        const total = progressEvent.total;
        // const current = progressEvent.loaded;

        if (total !== undefined) {
          // onProgress((current / total) * 100);
        }
      },
      signal: signal, // Pass the abort signal to the request
    });

    const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the object URL after the download
    URL.revokeObjectURL(pdfUrl);
  } catch (error) {
    if (axios.isCancel(error)) {
      onCancel();
    } else {
      console.error('Error downloading the file:', error);
    }
  }
};
